import React, { useEffect, useState } from 'react';
import api from '../../utils/api';
import CreateCategoryDrawer from './CreateCategoryDrawer';
import EditCategoryDrawer from './EditCategoryDrawer';

const CategoriesTable = () => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showDrawer, setShowDrawer] = useState(false);
  const [editDrawerOpen, setEditDrawerOpen] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);

  const fetchCategories = async () => {
    try {
      const res = await api.get('/api/categories');
      setCategories(res.data);
    } catch (err) {
      console.error('Error al cargar categorías:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  const openEditDrawer = (category) => {
    setSelectedCategory(category);
    setEditDrawerOpen(true);
  };

  return (
    <div className="max-w-6xl mx-auto px-4 py-8">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-800 mb-1">Gestión de Categorías</h1>
        <p className="text-gray-600 text-sm">Aquí puedes administrar las categorías de descargas.</p>
      </div>

      <div className="flex justify-end mb-4">
        <button
          className="px-4 py-2 bg-blue-800 text-white rounded hover:bg-blue-700 transition"
          onClick={() => setShowDrawer(true)}
        >
          + Categoría
        </button>
      </div>

      {loading ? (
        <p className="text-gray-500">Cargando...</p>
      ) : categories.length === 0 ? (
        <div className="bg-white shadow rounded-lg p-8 text-center border border-dashed border-gray-300">
          <h2 className="text-xl font-semibold text-gray-700">No hay categorías disponibles</h2>
          <p className="text-gray-500 mb-4">Agrega tu primera categoría.</p>
          <button
            onClick={() => setShowDrawer(true)}
            className="px-4 py-2 bg-blue-800 text-white rounded hover:bg-blue-700 transition"
          >
            + Categoría
          </button>
        </div>
      ) : (
        <div className="overflow-x-auto">
          <table className="min-w-full bg-white border rounded-lg">
            <thead className="bg-gray-100 text-gray-700">
              <tr>
                <th className="py-2 px-4 border-b text-left">Nombre</th>
                <th className="py-2 px-4 border-b text-left">Descripción</th>
                <th className="py-2 px-4 border-b text-left">Fecha de Creación</th>
                <th className="py-2 px-4 border-b text-left">Acciones</th>
              </tr>
            </thead>
            <tbody>
              {categories.map((category) => (
                <tr key={category.id} className="border-b hover:bg-gray-50">
                  <td className="py-2 px-4">{category.name}</td>
                  <td className="py-2 px-4">{category.description || '-'}</td>
                  <td className="py-2 px-4">{new Date(category.created_at).toLocaleDateString()}</td>
                  <td className="py-2 px-4">
                    <button
                      onClick={() => openEditDrawer(category)}
                      className="text-sm text-blue-700 hover:underline"
                    >
                      Editar
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      <CreateCategoryDrawer
        isOpen={showDrawer}
        onClose={() => setShowDrawer(false)}
        onCreated={fetchCategories}
      />

      <EditCategoryDrawer
        isOpen={editDrawerOpen}
        onClose={() => setEditDrawerOpen(false)}
        category={selectedCategory}
        onUpdated={fetchCategories}
      />
    </div>
  );
};

export default CategoriesTable;
